import { Params } from '@angular/router';

/**
 * Consent-freier Korrelationskontext des Landingpage-Demo-CTA.
 *
 * Die JourneyId ist eine zufällige Einmal-ID pro CTA-Klick und enthält keine
 * Personen- oder Formulardaten. Das Backend protokolliert sie strukturiert in
 * Seq, damit Marketing-Plattform und Demo-Sitzung exakt verknüpft werden können.
 */
export interface DemoStartAttribution {
  JourneyId: string | null;
  Cta: string | null;
  LandingPage: string | null;
  TrackingSchema: string | null;
}

function optionalParam(
  params: Params,
  key: string,
  maxLength: number
): string | null {
  const raw = params[key];
  if (typeof raw !== 'string') {
    return null;
  }
  const value = raw.trim();
  return value ? value.slice(0, maxLength) : null;
}

/** Mappt den kanonischen Landingpage-URL-Vertrag auf den PascalCase-API-Body. */
export function demoAttributionFromQueryParams(
  params: Params
): DemoStartAttribution {
  return {
    JourneyId: optionalParam(params, 'fp_journey', 64),
    Cta: optionalParam(params, 'cta', 100),
    LandingPage: optionalParam(params, 'pg', 256),
    TrackingSchema: optionalParam(params, 'fp_schema', 16),
  };
}
